import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { useLocation, useNavigate } from "react-router-dom";
import { TASKS_ALL_BY_USER_URL } from "../../Constants/Constants";

import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "../alerts/AlertContext";

import AppTableView from "../AppTableView";
import Grid from "@mui/material/Grid2";
import { IconButton } from "@mui/material";
import { TASKS_COLUMNS } from "./grid/GridDataConstants";
import TaskDialog from './TaskDialog';
import { USER_ID } from "../../Constants/StorageConstants";

function Tasks() {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      //backgroundColor: theme.palette.common.blue,
      backgroundColor: "#1976d2",
      color: theme.palette.common.white,
      paddingTop: 2,
      paddingBottom: 2,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
      paddingTop: 2,
      paddingBottom: 2,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));


  const location = useLocation();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);

  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [totalElements, setTotalElements] = useState(0);

  useEffect(() => {
    if (location.state?.openTicketDialog) {
      setOpenDialog(true);

      navigate(location.pathname, {
        replace: true,
        state: {}
      });
    }
    fetchTasks();
  }, [page, rowsPerPage, location.state]);

  const fetchTasks = () => {
    setLoading(true);
    AxiosInstance.post(TASKS_ALL_BY_USER_URL, {
      page: page,
      size: rowsPerPage,
      direction: "desc",
      sort: "createdOn",
      search: "",
      userId: localStorage.getItem(USER_ID)
    })
      .then((response) => {
        setTasks(response.data.content);
        setTotalElements(response.data.totalElements);
        setLoading(false);
      })
      .catch((err) => console.error(err));
  };


  return (
    <Container fluid>
      <Box
        sx={{
          padding: 2,
          paddingTop: 0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
        }}
      >
        <TaskDialog callTasks={fetchTasks} openDialog={openDialog}
          onClose={() => setOpenDialog(false)} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          {loading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid gap={2} container spacing={2} columns={12}>
              <Grid size={{ xs: 12, lg: 12 }}>
                <AppTableView
                  rows={tasks}
                  cols={TASKS_COLUMNS}
                  hasRowSelectableFn={() => null}
                  handleRowSelection={() => null}

                />
              </Grid>
            </Grid>
          )}
        </Paper>
      </Box>
    </Container>
  )


}
export default Tasks;